module.exports = __webpack_public_path__ + "files/9ff6bfe40c17bebee95d7e02f1954197.png";